import { Component, OnInit } from '@angular/core';

import { Licenciamento } from "../shared/licenciamento.model";
import { licenciamentosModuleName } from "../shared/data.service";
import { LicenciamentoApiService } from "../shared/licenciamento-api.service";
import { LicenciamentoNavigationService } from "../shared/licenciamento-navigation.service";
import { LicenciamentosService } from "../shared/licenciamento.service";
import { UtilService } from "../../../shared/services/util.service";
import {months} from "../../../abastecimentos/abastecimento-bens/shared/data.service";
import {DespachoService} from "../../shared/despacho.service";
import {configuracaoModuleName} from "../../../shared/services/data.service";
import {obrigacoesModuleName} from "../../obrigacoes/shared/data.service";

@Component({
    template: require('./licenciamento-list.component.html'),
    styles: [require('./licenciamento-list.component.css')]
})
export class LicenciamentoListComponent implements OnInit {
    list: Licenciamento[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    licenciamentosModuleName: any = licenciamentosModuleName;
    configuracaoModule: any = configuracaoModuleName;
    module: any = obrigacoesModuleName;

    private mesesList: any[] = [];

    constructor(
        private _licenciamentosApiService: LicenciamentoApiService,
        private _licenciamentosService: LicenciamentosService,
        private _licenciamentoNavigationService: LicenciamentoNavigationService,
        private _utilService: UtilService,
        private _despachoService: DespachoService
    ) { }

    ngOnInit() {
        this.mesesList = this._utilService.cloneObject(months);

        this.getAll();
    }

    clickNew() {
        this._licenciamentosService.clearSessionStorage();
        this._licenciamentoNavigationService.goToNew();
    }

    clickEdit(item: Licenciamento) {
        this._licenciamentosService.clearSessionStorage();
        this._licenciamentoNavigationService.goToEdit(item.id);
    }

    clickGoToConfig() {
        this._despachoService.goToSettingObrigacoes();
    }

    clickDelete(item: Licenciamento) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                Response.forEach(function(item: any) {
                    if (item.mes) {
                        item.mes = this.mesesList[item.mes];
                    }
                }.bind(this));
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._licenciamentosApiService.onGetAll(onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._licenciamentosApiService.onDelete(item.id, onDone);
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/licenciamentos/licenciamento-list/licenciamento-list.component.ts
 **/